import { useEffect } from 'react'
import { useEvaluationData } from './fetchEvalDatahook'

interface Props {
    evalID: string | null
    onData: (data: any) => void
    onLoading?: (loading: boolean) => void
    onError?: (error: Error | null) => void
    onTokenRefreshError?: (err: boolean) => void
}

const EvaluationDataProvider = ({
    evalID,
    onData,
    onLoading,
    onError,
    onTokenRefreshError,
}: Props) => {
    const { evaluationData, isLoading, error, tokenRefreshError } =
        useEvaluationData(evalID)

    useEffect(() => {
        if (evaluationData) {
            onData(evaluationData)
        }

        if (onLoading) {
            onLoading(isLoading)
        }

        if (onError) {
            onError(error)
        }

        if (onTokenRefreshError) {
            onTokenRefreshError(tokenRefreshError)
        }
    }, [
        evaluationData,
        isLoading,
        error,
        tokenRefreshError,
        onData,
        onLoading,
        onError,
        onTokenRefreshError,
    ])

    return null
}

export default EvaluationDataProvider
